export default __webpack_public_path__ + "static/media/2.992e85f8.gif";